import { render, staticRenderFns } from "./MenuAdmin.vue?vue&type=template&id=49b72f10&"
import script from "./MenuAdmin.vue?vue&type=script&lang=ts&"
export * from "./MenuAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports